export default __webpack_public_path__ + "static/media/Social Links.123f45f2.svg";